// extracted by css-extract-rspack-plugin
export default {"drawerTitle":"drawer-title_mwVMr"};